"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_query_1 = require("react-query");
var material_1 = require("@mui/material");
var trans_1 = __importDefault(require("@/plugins/trans"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
var VacancyAlertFrequency_1 = __importDefault(require("./VacancyAlertFrequency"));
var VacancyAlert_1 = require("../../models/VacancyAlert");
var classes = {
    main: {
        py: { xs: 10, md: 12 },
    },
    title: {
        mb: 8,
    },
    card: {
        backgroundColor: 'white',
        border: function (theme) { return "1px solid ".concat(theme.palette.primary.main); },
        borderRadius: '10px',
    },
    mainCard: {
        py: { xs: 4, md: 8 },
        px: { xs: 8, md: 14 },
    },
    alertCard: {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
    },
    alertCard__content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: '99 0 0%',
        py: { xs: 2, md: 4 },
        px: { xs: 4, md: 8 },
    },
    alertCard__title: {
        fontSize: '1.25rem',
        fontWeight: 500,
        color: function (theme) { return theme.palette.secondary.main; },
        mb: 2,
    },
    alertCard__actions: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        flex: 1,
        minWidth: 'max-content',
        backgroundColor: '#F4F2F4',
        py: { xs: 2, md: 4 },
        px: { xs: 4, md: 8 },
        borderRadius: { xs: '0 0 10px 10px', md: '0 10px 10px 0' },
        '& > a': {
            color: function (theme) { return theme.palette.secondary.main; },
            display: 'grid',
            gridAutoFlow: 'column',
            gap: 3,
        },
        '& > *+*': {
            mt: 4,
        },
    },
};
var VacancyAlertsPage = function () {
    var vacancyAlerts = (0, react_query_1.useQuery)('vacancy_alerts', VacancyAlert_1.getAll);
    return ((0, jsx_runtime_1.jsx)(material_1.Container, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.main }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h2", color: "secondary", sx: classes.title }, { children: "Beheer mijn job alerts" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: __assign(__assign({}, classes.card), classes.mainCard) }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "card-content flex direction-column" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    mb: 10,
                                    flexDirection: { xs: 'column-reverse', md: 'row' },
                                    '&>a': {
                                        backgroundColor: 'secondary.main',
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: 'white',
                                        textDecoration: 'none',
                                        py: 3,
                                        px: 6,
                                        borderRadius: '50px',
                                        height: 'max-content',
                                        mb: { xs: 4, md: 0 },
                                    },
                                } }, { children: [(0, jsx_runtime_1.jsx)(VacancyAlertFrequency_1.default, {}), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, __assign({ to: "add" }, { children: [(0, jsx_runtime_1.jsx)(Add_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: {
                                                    ml: 2,
                                                } }, { children: trans_1.default.get('buttons.general.add') }))] }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
                                    gap: 6,
                                } }, { children: vacancyAlerts.data ? ((0, lodash_1.map)(vacancyAlerts.data.data, function (vacancyAlert) { return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: __assign(__assign({}, classes.card), classes.alertCard) }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.alertCard__content }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: classes.alertCard__title }, { children: vacancyAlert.search_terms })), (0, jsx_runtime_1.jsxs)(material_1.Typography, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { fontWeight: 500 }, component: "span" }, { children: trans_1.default.get('labels.general.location') })), ": ", vacancyAlert.location_address] }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { fontWeight: 500 }, component: "span" }, { children: [trans_1.default.get('labels.frontend.vacancy.distance'), " (km)"] })), ": ", vacancyAlert.distance] })] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.alertCard__actions }, { children: [(0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, __assign({ to: "edit/".concat(vacancyAlert.id) }, { children: [trans_1.default.get('buttons.general.crud.edit'), (0, jsx_runtime_1.jsx)(Edit_1.default, {})] })), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, __assign({ to: "delete/".concat(vacancyAlert.id) }, { children: [trans_1.default.get('buttons.general.crud.delete'), (0, jsx_runtime_1.jsx)(Delete_1.default, {})] }))] }))] }), vacancyAlert.id)); })) : ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", justifyContent: "center", width: "100%" }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) }))) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] })) }))] })) }));
};
exports.default = VacancyAlertsPage;
